import { supabase } from './supabase.js';

export async function fetchListingTransactionMessages(transactionId) {
  const id = String(transactionId ?? '').trim();
  if (!id) return { messages: [], error: 'missing_transaction' };
  const { data, error } = await supabase.rpc('list_listing_transaction_messages', {
    p_transaction_id: id,
  });
  if (error) {
    console.error('[listingTransactionMessagesService] fetch', error.message);
    return { messages: [], error: error.message };
  }
  return { messages: Array.isArray(data) ? data : [], error: null };
}

export async function sendListingTransactionMessage(transactionId, body, kind = 'text') {
  const id = String(transactionId ?? '').trim();
  const text = String(body ?? '').trim();
  if (!id || !text) return { messageId: null, error: 'missing_fields' };
  const { data, error } = await supabase.rpc('insert_listing_transaction_message', {
    p_transaction_id: id,
    p_body: text,
    p_kind: kind,
  });
  if (error) {
    console.error('[listingTransactionMessagesService] send', error.message);
    return { messageId: null, error: error.message };
  }
  return { messageId: data ?? null, error: null };
}
